module.exports = __webpack_public_path__ + "static/ppc-ddd7e7c198fb2cd698527d89bea1d77b.svg";